import { getTimezone } from 'countries-and-timezones'

export type CityEntry = {
  city: string
  country: string
  timezone: string
  aliases?: string[]
}

export const CITY_TIMEZONES: CityEntry[] = [
  // ============================================================
  // NORTH AMERICA - Eastern (UTC-5)
  // ============================================================
  {
    city: 'New York',
    country: 'US',
    timezone: 'America/New_York',
    aliases: ['NYC', 'Manhattan', 'Brooklyn'],
  },
  { city: 'Boston', country: 'US', timezone: 'America/New_York' },
  { city: 'Philadelphia', country: 'US', timezone: 'America/New_York' },
  { city: 'Miami', country: 'US', timezone: 'America/New_York' },
  { city: 'Atlanta', country: 'US', timezone: 'America/New_York' },
  {
    city: 'Washington DC',
    country: 'US',
    timezone: 'America/New_York',
    aliases: ['DC', 'Washington'],
  },
  { city: 'Charlotte', country: 'US', timezone: 'America/New_York' },
  { city: 'Orlando', country: 'US', timezone: 'America/New_York' },
  { city: 'Pittsburgh', country: 'US', timezone: 'America/New_York' },
  { city: 'Raleigh', country: 'US', timezone: 'America/New_York' },
  { city: 'Baltimore', country: 'US', timezone: 'America/New_York' },
  { city: 'Tampa', country: 'US', timezone: 'America/New_York' },
  { city: 'Detroit', country: 'US', timezone: 'America/Detroit' },
  { city: 'Toronto', country: 'CA', timezone: 'America/Toronto' },
  { city: 'Ottawa', country: 'CA', timezone: 'America/Toronto' },
  { city: 'Montreal', country: 'CA', timezone: 'America/Toronto' },
  {
    city: 'Indianapolis',
    country: 'US',
    timezone: 'America/Indiana/Indianapolis',
  },
  {
    city: 'Louisville',
    country: 'US',
    timezone: 'America/Kentucky/Louisville',
  },
  {
    city: 'Monticello',
    country: 'US',
    timezone: 'America/Kentucky/Monticello',
  },
  { city: 'Knox', country: 'US', timezone: 'America/Indiana/Knox' },
  { city: 'Marengo', country: 'US', timezone: 'America/Indiana/Marengo' },
  { city: 'Petersburg', country: 'US', timezone: 'America/Indiana/Petersburg' },
  { city: 'Tell City', country: 'US', timezone: 'America/Indiana/Tell_City' },
  { city: 'Vevay', country: 'US', timezone: 'America/Indiana/Vevay' },
  { city: 'Vincennes', country: 'US', timezone: 'America/Indiana/Vincennes' },
  { city: 'Winamac', country: 'US', timezone: 'America/Indiana/Winamac' },
  { city: 'Beulah', country: 'US', timezone: 'America/North_Dakota/Beulah' },
  { city: 'Center', country: 'US', timezone: 'America/North_Dakota/Center' },
  {
    city: 'New Salem',
    country: 'US',
    timezone: 'America/North_Dakota/New_Salem',
  },
  { city: 'Iqaluit', country: 'CA', timezone: 'America/Iqaluit' },

  // ============================================================
  // NORTH AMERICA - Central (UTC-6)
  // ============================================================
  {
    city: 'Chicago',
    country: 'US',
    timezone: 'America/Chicago',
    aliases: ['Chi-Town'],
  },
  {
    city: 'Dallas',
    country: 'US',
    timezone: 'America/Chicago',
    aliases: ['DFW'],
  },
  { city: 'Houston', country: 'US', timezone: 'America/Chicago' },
  { city: 'Austin', country: 'US', timezone: 'America/Chicago' },
  { city: 'San Antonio', country: 'US', timezone: 'America/Chicago' },
  { city: 'Minneapolis', country: 'US', timezone: 'America/Chicago' },
  { city: 'Nashville', country: 'US', timezone: 'America/Chicago' },
  { city: 'Milwaukee', country: 'US', timezone: 'America/Chicago' },
  { city: 'Kansas City', country: 'US', timezone: 'America/Chicago' },
  { city: 'New Orleans', country: 'US', timezone: 'America/Chicago' },
  {
    city: 'St Louis',
    country: 'US',
    timezone: 'America/Chicago',
    aliases: ['Saint Louis'],
  },
  { city: 'Memphis', country: 'US', timezone: 'America/Chicago' },
  { city: 'Oklahoma City', country: 'US', timezone: 'America/Chicago' },
  { city: 'Winnipeg', country: 'CA', timezone: 'America/Winnipeg' },
  { city: 'Menominee', country: 'US', timezone: 'America/Menominee' },
  { city: 'Matamoros', country: 'MX', timezone: 'America/Matamoros' },
  { city: 'Rankin Inlet', country: 'CA', timezone: 'America/Rankin_Inlet' },
  { city: 'Resolute', country: 'CA', timezone: 'America/Resolute' },

  // ============================================================
  // NORTH AMERICA - Mountain (UTC-7)
  // ============================================================
  { city: 'Denver', country: 'US', timezone: 'America/Denver' },
  {
    city: 'Salt Lake City',
    country: 'US',
    timezone: 'America/Denver',
    aliases: ['SLC'],
  },
  { city: 'Albuquerque', country: 'US', timezone: 'America/Denver' },
  { city: 'Colorado Springs', country: 'US', timezone: 'America/Denver' },
  { city: 'Edmonton', country: 'CA', timezone: 'America/Edmonton' },
  { city: 'Calgary', country: 'CA', timezone: 'America/Edmonton' },
  { city: 'Boise', country: 'US', timezone: 'America/Boise' },
  {
    city: 'Phoenix',
    country: 'US',
    timezone: 'America/Phoenix',
    aliases: ['PHX'],
  },
  { city: 'Tucson', country: 'US', timezone: 'America/Phoenix' },
  { city: 'Cambridge Bay', country: 'CA', timezone: 'America/Cambridge_Bay' },
  { city: 'Inuvik', country: 'CA', timezone: 'America/Inuvik' },
  { city: 'Ciudad Juarez', country: 'MX', timezone: 'America/Ciudad_Juarez' },
  { city: 'Ojinaga', country: 'MX', timezone: 'America/Ojinaga' },

  // ============================================================
  // NORTH AMERICA - Pacific (UTC-8)
  // ============================================================
  {
    city: 'Los Angeles',
    country: 'US',
    timezone: 'America/Los_Angeles',
    aliases: ['LA', 'Hollywood'],
  },
  {
    city: 'San Francisco',
    country: 'US',
    timezone: 'America/Los_Angeles',
    aliases: ['SF', 'Bay Area', 'Silicon Valley'],
  },
  { city: 'Seattle', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'Portland', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'San Diego', country: 'US', timezone: 'America/Los_Angeles' },
  {
    city: 'Las Vegas',
    country: 'US',
    timezone: 'America/Los_Angeles',
    aliases: ['Vegas'],
  },
  { city: 'Sacramento', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'Vancouver', country: 'CA', timezone: 'America/Vancouver' },
  { city: 'Tijuana', country: 'MX', timezone: 'America/Tijuana' },

  // ============================================================
  // NORTH AMERICA - Alaska & Hawaii
  // ============================================================
  { city: 'Anchorage', country: 'US', timezone: 'America/Anchorage' },
  { city: 'Juneau', country: 'US', timezone: 'America/Juneau' },
  { city: 'Sitka', country: 'US', timezone: 'America/Sitka' },
  { city: 'Metlakatla', country: 'US', timezone: 'America/Metlakatla' },
  { city: 'Nome', country: 'US', timezone: 'America/Nome' },
  { city: 'Yakutat', country: 'US', timezone: 'America/Yakutat' },
  { city: 'Adak', country: 'US', timezone: 'America/Adak' },
  {
    city: 'Honolulu',
    country: 'US',
    timezone: 'Pacific/Honolulu',
    aliases: ['Hawaii'],
  },

  // ============================================================
  // CANADA - Atlantic & Newfoundland
  // ============================================================
  { city: 'Halifax', country: 'CA', timezone: 'America/Halifax' },
  { city: 'Moncton', country: 'CA', timezone: 'America/Moncton' },
  { city: 'Glace Bay', country: 'CA', timezone: 'America/Glace_Bay' },
  { city: 'Goose Bay', country: 'CA', timezone: 'America/Goose_Bay' },
  {
    city: "St John's",
    country: 'CA',
    timezone: 'America/St_Johns',
    aliases: ['Saint Johns'],
  },

  // ============================================================
  // CANADA - Other
  // ============================================================
  { city: 'Regina', country: 'CA', timezone: 'America/Regina' },
  { city: 'Swift Current', country: 'CA', timezone: 'America/Swift_Current' },
  { city: 'Whitehorse', country: 'CA', timezone: 'America/Whitehorse' },
  { city: 'Dawson', country: 'CA', timezone: 'America/Dawson' },
  { city: 'Dawson Creek', country: 'CA', timezone: 'America/Dawson_Creek' },
  { city: 'Fort Nelson', country: 'CA', timezone: 'America/Fort_Nelson' },

  // ============================================================
  // MEXICO
  // ============================================================
  {
    city: 'Mexico City',
    country: 'MX',
    timezone: 'America/Mexico_City',
    aliases: ['CDMX'],
  },
  { city: 'Cancun', country: 'MX', timezone: 'America/Cancun' },
  { city: 'Merida', country: 'MX', timezone: 'America/Merida' },
  { city: 'Monterrey', country: 'MX', timezone: 'America/Monterrey' },
  { city: 'Mazatlan', country: 'MX', timezone: 'America/Mazatlan' },
  { city: 'Chihuahua', country: 'MX', timezone: 'America/Chihuahua' },
  { city: 'Hermosillo', country: 'MX', timezone: 'America/Hermosillo' },
  { city: 'Bahia Banderas', country: 'MX', timezone: 'America/Bahia_Banderas' },

  // ============================================================
  // CENTRAL AMERICA & CARIBBEAN
  // ============================================================
  { city: 'Guatemala City', country: 'GT', timezone: 'America/Guatemala' },
  { city: 'Tegucigalpa', country: 'HN', timezone: 'America/Tegucigalpa' },
  { city: 'San Salvador', country: 'SV', timezone: 'America/El_Salvador' },
  { city: 'Managua', country: 'NI', timezone: 'America/Managua' },
  { city: 'San Jose', country: 'CR', timezone: 'America/Costa_Rica' },
  { city: 'Belize City', country: 'BZ', timezone: 'America/Belize' },
  { city: 'Panama City', country: 'PA', timezone: 'America/Panama' },
  { city: 'Havana', country: 'CU', timezone: 'America/Havana' },
  { city: 'Kingston', country: 'JM', timezone: 'America/Jamaica' },
  { city: 'Santo Domingo', country: 'DO', timezone: 'America/Santo_Domingo' },
  { city: 'Port-au-Prince', country: 'HT', timezone: 'America/Port-au-Prince' },
  { city: 'San Juan', country: 'PR', timezone: 'America/Puerto_Rico' },
  { city: 'Barbados', country: 'BB', timezone: 'America/Barbados' },
  { city: 'Fort-de-France', country: 'MQ', timezone: 'America/Martinique' },
  { city: 'Grand Turk', country: 'TC', timezone: 'America/Grand_Turk' },

  // ============================================================
  // SOUTH AMERICA
  // ============================================================
  {
    city: 'Sao Paulo',
    country: 'BR',
    timezone: 'America/Sao_Paulo',
    aliases: ['São Paulo'],
  },
  {
    city: 'Rio de Janeiro',
    country: 'BR',
    timezone: 'America/Sao_Paulo',
    aliases: ['Rio'],
  },
  {
    city: 'Buenos Aires',
    country: 'AR',
    timezone: 'America/Argentina/Buenos_Aires',
  },
  {
    city: 'Cordoba',
    country: 'AR',
    timezone: 'America/Argentina/Cordoba',
    aliases: ['Córdoba'],
  },
  { city: 'Catamarca', country: 'AR', timezone: 'America/Argentina/Catamarca' },
  { city: 'Jujuy', country: 'AR', timezone: 'America/Argentina/Jujuy' },
  { city: 'La Rioja', country: 'AR', timezone: 'America/Argentina/La_Rioja' },
  { city: 'Mendoza', country: 'AR', timezone: 'America/Argentina/Mendoza' },
  {
    city: 'Rio Gallegos',
    country: 'AR',
    timezone: 'America/Argentina/Rio_Gallegos',
  },
  { city: 'Salta', country: 'AR', timezone: 'America/Argentina/Salta' },
  { city: 'San Juan', country: 'AR', timezone: 'America/Argentina/San_Juan' },
  { city: 'San Luis', country: 'AR', timezone: 'America/Argentina/San_Luis' },
  { city: 'Tucuman', country: 'AR', timezone: 'America/Argentina/Tucuman' },
  { city: 'Ushuaia', country: 'AR', timezone: 'America/Argentina/Ushuaia' },
  { city: 'Santiago', country: 'CL', timezone: 'America/Santiago' },
  { city: 'Punta Arenas', country: 'CL', timezone: 'America/Punta_Arenas' },
  {
    city: 'Bogota',
    country: 'CO',
    timezone: 'America/Bogota',
    aliases: ['Bogotá'],
  },
  {
    city: 'Medellin',
    country: 'CO',
    timezone: 'America/Bogota',
    aliases: ['Medellín'],
  },
  { city: 'Lima', country: 'PE', timezone: 'America/Lima' },
  { city: 'Quito', country: 'EC', timezone: 'America/Guayaquil' },
  { city: 'Guayaquil', country: 'EC', timezone: 'America/Guayaquil' },
  { city: 'Caracas', country: 'VE', timezone: 'America/Caracas' },
  { city: 'La Paz', country: 'BO', timezone: 'America/La_Paz' },
  { city: 'Montevideo', country: 'UY', timezone: 'America/Montevideo' },
  {
    city: 'Asuncion',
    country: 'PY',
    timezone: 'America/Asuncion',
    aliases: ['Asunción'],
  },
  { city: 'Georgetown', country: 'GY', timezone: 'America/Guyana' },
  { city: 'Paramaribo', country: 'SR', timezone: 'America/Paramaribo' },
  { city: 'Cayenne', country: 'GF', timezone: 'America/Cayenne' },
  { city: 'Stanley', country: 'FK', timezone: 'Atlantic/Stanley' },

  // ============================================================
  // BRAZIL - Regional
  // ============================================================
  { city: 'Fortaleza', country: 'BR', timezone: 'America/Fortaleza' },
  { city: 'Recife', country: 'BR', timezone: 'America/Recife' },
  { city: 'Belem', country: 'BR', timezone: 'America/Belem' },
  { city: 'Maceio', country: 'BR', timezone: 'America/Maceio' },
  {
    city: 'Bahia',
    country: 'BR',
    timezone: 'America/Bahia',
    aliases: ['Salvador'],
  },
  { city: 'Araguaina', country: 'BR', timezone: 'America/Araguaina' },
  { city: 'Santarem', country: 'BR', timezone: 'America/Santarem' },
  { city: 'Manaus', country: 'BR', timezone: 'America/Manaus' },
  { city: 'Campo Grande', country: 'BR', timezone: 'America/Campo_Grande' },
  {
    city: 'Cuiaba',
    country: 'BR',
    timezone: 'America/Cuiaba',
    aliases: ['Cuiabá'],
  },
  { city: 'Porto Velho', country: 'BR', timezone: 'America/Porto_Velho' },
  { city: 'Boa Vista', country: 'BR', timezone: 'America/Boa_Vista' },
  { city: 'Eirunepe', country: 'BR', timezone: 'America/Eirunepe' },
  { city: 'Rio Branco', country: 'BR', timezone: 'America/Rio_Branco' },
  {
    city: 'Noronha',
    country: 'BR',
    timezone: 'America/Noronha',
    aliases: ['Fernando de Noronha'],
  },

  // ============================================================
  // EUROPE - Western (UTC+0 / UTC+1)
  // ============================================================
  { city: 'London', country: 'GB', timezone: 'Europe/London' },
  { city: 'Manchester', country: 'GB', timezone: 'Europe/London' },
  { city: 'Birmingham', country: 'GB', timezone: 'Europe/London' },
  { city: 'Edinburgh', country: 'GB', timezone: 'Europe/London' },
  { city: 'Dublin', country: 'IE', timezone: 'Europe/Dublin' },
  { city: 'Lisbon', country: 'PT', timezone: 'Europe/Lisbon' },
  { city: 'Porto', country: 'PT', timezone: 'Europe/Lisbon' },

  // ============================================================
  // EUROPE - Central (UTC+1 / UTC+2)
  // ============================================================
  { city: 'Paris', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Lyon', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Marseille', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Berlin', country: 'DE', timezone: 'Europe/Berlin' },
  {
    city: 'Munich',
    country: 'DE',
    timezone: 'Europe/Berlin',
    aliases: ['München'],
  },
  { city: 'Frankfurt', country: 'DE', timezone: 'Europe/Berlin' },
  { city: 'Hamburg', country: 'DE', timezone: 'Europe/Berlin' },
  {
    city: 'Cologne',
    country: 'DE',
    timezone: 'Europe/Berlin',
    aliases: ['Köln'],
  },
  { city: 'Amsterdam', country: 'NL', timezone: 'Europe/Brussels' },
  { city: 'Brussels', country: 'BE', timezone: 'Europe/Brussels' },
  { city: 'Madrid', country: 'ES', timezone: 'Europe/Madrid' },
  { city: 'Barcelona', country: 'ES', timezone: 'Europe/Madrid' },
  {
    city: 'Seville',
    country: 'ES',
    timezone: 'Europe/Madrid',
    aliases: ['Sevilla'],
  },
  { city: 'Rome', country: 'IT', timezone: 'Europe/Rome' },
  {
    city: 'Milan',
    country: 'IT',
    timezone: 'Europe/Rome',
    aliases: ['Milano'],
  },
  {
    city: 'Naples',
    country: 'IT',
    timezone: 'Europe/Rome',
    aliases: ['Napoli'],
  },
  {
    city: 'Vienna',
    country: 'AT',
    timezone: 'Europe/Vienna',
    aliases: ['Wien'],
  },
  {
    city: 'Zurich',
    country: 'CH',
    timezone: 'Europe/Zurich',
    aliases: ['Zürich'],
  },
  {
    city: 'Geneva',
    country: 'CH',
    timezone: 'Europe/Zurich',
    aliases: ['Genève'],
  },
  { city: 'Prague', country: 'CZ', timezone: 'Europe/Prague' },
  { city: 'Warsaw', country: 'PL', timezone: 'Europe/Warsaw' },
  {
    city: 'Krakow',
    country: 'PL',
    timezone: 'Europe/Warsaw',
    aliases: ['Kraków'],
  },
  { city: 'Budapest', country: 'HU', timezone: 'Europe/Budapest' },
  { city: 'Copenhagen', country: 'DK', timezone: 'Europe/Berlin' },
  { city: 'Stockholm', country: 'SE', timezone: 'Europe/Berlin' },
  { city: 'Oslo', country: 'NO', timezone: 'Europe/Berlin' },
  { city: 'Belgrade', country: 'RS', timezone: 'Europe/Belgrade' },
  { city: 'Zagreb', country: 'HR', timezone: 'Europe/Belgrade' },
  { city: 'Ljubljana', country: 'SI', timezone: 'Europe/Belgrade' },
  { city: 'Sarajevo', country: 'BA', timezone: 'Europe/Belgrade' },
  { city: 'Skopje', country: 'MK', timezone: 'Europe/Belgrade' },
  { city: 'Podgorica', country: 'ME', timezone: 'Europe/Belgrade' },
  {
    city: 'Malta',
    country: 'MT',
    timezone: 'Europe/Malta',
    aliases: ['Valletta'],
  },
  { city: 'Andorra la Vella', country: 'AD', timezone: 'Europe/Andorra' },
  { city: 'Tirana', country: 'AL', timezone: 'Europe/Tirane' },
  { city: 'Gibraltar', country: 'GI', timezone: 'Europe/Gibraltar' },
  { city: 'Ceuta', country: 'ES', timezone: 'Africa/Ceuta' },

  // ============================================================
  // EUROPE - Eastern (UTC+2 / UTC+3)
  // ============================================================
  { city: 'Athens', country: 'GR', timezone: 'Europe/Athens' },
  { city: 'Helsinki', country: 'FI', timezone: 'Europe/Helsinki' },
  { city: 'Bucharest', country: 'RO', timezone: 'Europe/Bucharest' },
  { city: 'Sofia', country: 'BG', timezone: 'Europe/Sofia' },
  { city: 'Kyiv', country: 'UA', timezone: 'Europe/Kyiv', aliases: ['Kiev'] },
  { city: 'Tallinn', country: 'EE', timezone: 'Europe/Tallinn' },
  { city: 'Riga', country: 'LV', timezone: 'Europe/Riga' },
  { city: 'Vilnius', country: 'LT', timezone: 'Europe/Vilnius' },
  {
    city: 'Chisinau',
    country: 'MD',
    timezone: 'Europe/Chisinau',
    aliases: ['Kishinev'],
  },
  { city: 'Nicosia', country: 'CY', timezone: 'Asia/Nicosia' },
  { city: 'Famagusta', country: 'CY', timezone: 'Asia/Famagusta' },
  { city: 'Istanbul', country: 'TR', timezone: 'Europe/Istanbul' },

  // ============================================================
  // EUROPE - Russia & Further East
  // ============================================================
  { city: 'Moscow', country: 'RU', timezone: 'Europe/Moscow' },
  {
    city: 'St Petersburg',
    country: 'RU',
    timezone: 'Europe/Moscow',
    aliases: ['Saint Petersburg'],
  },
  { city: 'Kaliningrad', country: 'RU', timezone: 'Europe/Kaliningrad' },
  { city: 'Minsk', country: 'BY', timezone: 'Europe/Minsk' },
  { city: 'Volgograd', country: 'RU', timezone: 'Europe/Volgograd' },
  { city: 'Samara', country: 'RU', timezone: 'Europe/Samara' },
  { city: 'Saratov', country: 'RU', timezone: 'Europe/Saratov' },
  { city: 'Astrakhan', country: 'RU', timezone: 'Europe/Astrakhan' },
  { city: 'Ulyanovsk', country: 'RU', timezone: 'Europe/Ulyanovsk' },
  { city: 'Kirov', country: 'RU', timezone: 'Europe/Kirov' },
  { city: 'Simferopol', country: 'UA', timezone: 'Europe/Simferopol' },

  // ============================================================
  // MIDDLE EAST
  // ============================================================
  {
    city: 'Dubai',
    country: 'AE',
    timezone: 'Asia/Dubai',
    aliases: ['Abu Dhabi'],
  },
  { city: 'Riyadh', country: 'SA', timezone: 'Asia/Riyadh' },
  { city: 'Jeddah', country: 'SA', timezone: 'Asia/Riyadh' },
  {
    city: 'Mecca',
    country: 'SA',
    timezone: 'Asia/Riyadh',
    aliases: ['Makkah'],
  },
  { city: 'Doha', country: 'QA', timezone: 'Asia/Qatar' },
  { city: 'Kuwait City', country: 'KW', timezone: 'Asia/Riyadh' },
  { city: 'Muscat', country: 'OM', timezone: 'Asia/Dubai' },
  { city: 'Baghdad', country: 'IQ', timezone: 'Asia/Baghdad' },
  { city: 'Tehran', country: 'IR', timezone: 'Asia/Tehran' },
  { city: 'Amman', country: 'JO', timezone: 'Asia/Amman' },
  { city: 'Beirut', country: 'LB', timezone: 'Asia/Beirut' },
  { city: 'Damascus', country: 'SY', timezone: 'Asia/Damascus' },
  {
    city: 'Jerusalem',
    country: 'IL',
    timezone: 'Asia/Jerusalem',
    aliases: ['Tel Aviv'],
  },
  { city: 'Gaza', country: 'PS', timezone: 'Asia/Gaza' },
  { city: 'Hebron', country: 'PS', timezone: 'Asia/Hebron' },
  { city: 'Baku', country: 'AZ', timezone: 'Asia/Baku' },
  { city: 'Tbilisi', country: 'GE', timezone: 'Asia/Tbilisi' },
  { city: 'Yerevan', country: 'AM', timezone: 'Asia/Yerevan' },

  // ============================================================
  // CENTRAL ASIA
  // ============================================================
  { city: 'Almaty', country: 'KZ', timezone: 'Asia/Almaty' },
  {
    city: 'Astana',
    country: 'KZ',
    timezone: 'Asia/Almaty',
    aliases: ['Nur-Sultan'],
  },
  { city: 'Aqtau', country: 'KZ', timezone: 'Asia/Aqtau' },
  {
    city: 'Aqtobe',
    country: 'KZ',
    timezone: 'Asia/Aqtobe',
    aliases: ['Aktobe'],
  },
  { city: 'Atyrau', country: 'KZ', timezone: 'Asia/Atyrau' },
  { city: 'Oral', country: 'KZ', timezone: 'Asia/Oral' },
  {
    city: 'Qostanay',
    country: 'KZ',
    timezone: 'Asia/Qostanay',
    aliases: ['Kostanay'],
  },
  { city: 'Qyzylorda', country: 'KZ', timezone: 'Asia/Qyzylorda' },
  { city: 'Tashkent', country: 'UZ', timezone: 'Asia/Tashkent' },
  { city: 'Samarkand', country: 'UZ', timezone: 'Asia/Samarkand' },
  { city: 'Bishkek', country: 'KG', timezone: 'Asia/Bishkek' },
  { city: 'Dushanbe', country: 'TJ', timezone: 'Asia/Dushanbe' },
  { city: 'Ashgabat', country: 'TM', timezone: 'Asia/Ashgabat' },
  { city: 'Kabul', country: 'AF', timezone: 'Asia/Kabul' },

  // ============================================================
  // SOUTH ASIA
  // ============================================================
  {
    city: 'Mumbai',
    country: 'IN',
    timezone: 'Asia/Kolkata',
    aliases: ['Bombay'],
  },
  {
    city: 'Delhi',
    country: 'IN',
    timezone: 'Asia/Kolkata',
    aliases: ['New Delhi'],
  },
  {
    city: 'Bangalore',
    country: 'IN',
    timezone: 'Asia/Kolkata',
    aliases: ['Bengaluru'],
  },
  {
    city: 'Kolkata',
    country: 'IN',
    timezone: 'Asia/Kolkata',
    aliases: ['Calcutta'],
  },
  {
    city: 'Chennai',
    country: 'IN',
    timezone: 'Asia/Kolkata',
    aliases: ['Madras'],
  },
  { city: 'Hyderabad', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Pune', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Karachi', country: 'PK', timezone: 'Asia/Karachi' },
  { city: 'Lahore', country: 'PK', timezone: 'Asia/Karachi' },
  { city: 'Islamabad', country: 'PK', timezone: 'Asia/Karachi' },
  { city: 'Colombo', country: 'LK', timezone: 'Asia/Colombo' },
  { city: 'Dhaka', country: 'BD', timezone: 'Asia/Dhaka' },
  { city: 'Kathmandu', country: 'NP', timezone: 'Asia/Kathmandu' },
  { city: 'Thimphu', country: 'BT', timezone: 'Asia/Thimphu' },

  // ============================================================
  // EAST ASIA
  // ============================================================
  { city: 'Tokyo', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Osaka', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Kyoto', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Shanghai', country: 'CN', timezone: 'Asia/Shanghai' },
  {
    city: 'Beijing',
    country: 'CN',
    timezone: 'Asia/Shanghai',
    aliases: ['Peking'],
  },
  { city: 'Shenzhen', country: 'CN', timezone: 'Asia/Shanghai' },
  {
    city: 'Guangzhou',
    country: 'CN',
    timezone: 'Asia/Shanghai',
    aliases: ['Canton'],
  },
  { city: 'Chengdu', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Urumqi', country: 'CN', timezone: 'Asia/Urumqi' },
  {
    city: 'Hong Kong',
    country: 'HK',
    timezone: 'Asia/Hong_Kong',
    aliases: ['HK'],
  },
  { city: 'Macau', country: 'MO', timezone: 'Asia/Macau', aliases: ['Macao'] },
  { city: 'Taipei', country: 'TW', timezone: 'Asia/Taipei' },
  { city: 'Seoul', country: 'KR', timezone: 'Asia/Seoul' },
  { city: 'Busan', country: 'KR', timezone: 'Asia/Seoul' },
  { city: 'Pyongyang', country: 'KP', timezone: 'Asia/Pyongyang' },
  { city: 'Ulaanbaatar', country: 'MN', timezone: 'Asia/Ulaanbaatar' },
  { city: 'Hovd', country: 'MN', timezone: 'Asia/Hovd' },

  // ============================================================
  // SOUTHEAST ASIA
  // ============================================================
  { city: 'Singapore', country: 'SG', timezone: 'Asia/Singapore' },
  { city: 'Bangkok', country: 'TH', timezone: 'Asia/Bangkok' },
  {
    city: 'Ho Chi Minh City',
    country: 'VN',
    timezone: 'Asia/Ho_Chi_Minh',
    aliases: ['Saigon', 'HCMC'],
  },
  { city: 'Hanoi', country: 'VN', timezone: 'Asia/Bangkok' },
  { city: 'Jakarta', country: 'ID', timezone: 'Asia/Jakarta' },
  {
    city: 'Bali',
    country: 'ID',
    timezone: 'Asia/Makassar',
    aliases: ['Denpasar'],
  },
  { city: 'Makassar', country: 'ID', timezone: 'Asia/Makassar' },
  { city: 'Jayapura', country: 'ID', timezone: 'Asia/Jayapura' },
  { city: 'Pontianak', country: 'ID', timezone: 'Asia/Pontianak' },
  {
    city: 'Kuala Lumpur',
    country: 'MY',
    timezone: 'Asia/Singapore',
    aliases: ['KL'],
  },
  { city: 'Kuching', country: 'MY', timezone: 'Asia/Kuching' },
  { city: 'Manila', country: 'PH', timezone: 'Asia/Manila' },
  {
    city: 'Yangon',
    country: 'MM',
    timezone: 'Asia/Yangon',
    aliases: ['Rangoon'],
  },
  { city: 'Dili', country: 'TL', timezone: 'Asia/Dili' },
  { city: 'Phnom Penh', country: 'KH', timezone: 'Asia/Bangkok' },

  // ============================================================
  // RUSSIA - Siberia & Far East
  // ============================================================
  { city: 'Yekaterinburg', country: 'RU', timezone: 'Asia/Yekaterinburg' },
  { city: 'Omsk', country: 'RU', timezone: 'Asia/Omsk' },
  { city: 'Novosibirsk', country: 'RU', timezone: 'Asia/Novosibirsk' },
  { city: 'Novokuznetsk', country: 'RU', timezone: 'Asia/Novokuznetsk' },
  { city: 'Barnaul', country: 'RU', timezone: 'Asia/Barnaul' },
  { city: 'Tomsk', country: 'RU', timezone: 'Asia/Tomsk' },
  { city: 'Krasnoyarsk', country: 'RU', timezone: 'Asia/Krasnoyarsk' },
  { city: 'Irkutsk', country: 'RU', timezone: 'Asia/Irkutsk' },
  { city: 'Chita', country: 'RU', timezone: 'Asia/Chita' },
  { city: 'Yakutsk', country: 'RU', timezone: 'Asia/Yakutsk' },
  { city: 'Khandyga', country: 'RU', timezone: 'Asia/Khandyga' },
  { city: 'Vladivostok', country: 'RU', timezone: 'Asia/Vladivostok' },
  { city: 'Ust-Nera', country: 'RU', timezone: 'Asia/Ust-Nera' },
  { city: 'Srednekolymsk', country: 'RU', timezone: 'Asia/Srednekolymsk' },
  { city: 'Magadan', country: 'RU', timezone: 'Asia/Magadan' },
  { city: 'Sakhalin', country: 'RU', timezone: 'Asia/Sakhalin' },
  {
    city: 'Kamchatka',
    country: 'RU',
    timezone: 'Asia/Kamchatka',
    aliases: ['Petropavlovsk-Kamchatsky'],
  },
  { city: 'Anadyr', country: 'RU', timezone: 'Asia/Anadyr' },

  // ============================================================
  // AFRICA - North
  // ============================================================
  { city: 'Cairo', country: 'EG', timezone: 'Africa/Cairo' },
  { city: 'Alexandria', country: 'EG', timezone: 'Africa/Cairo' },
  { city: 'Casablanca', country: 'MA', timezone: 'Africa/Casablanca' },
  { city: 'Rabat', country: 'MA', timezone: 'Africa/Casablanca' },
  { city: 'Algiers', country: 'DZ', timezone: 'Africa/Algiers' },
  { city: 'Tunis', country: 'TN', timezone: 'Africa/Tunis' },
  { city: 'Tripoli', country: 'LY', timezone: 'Africa/Tripoli' },
  {
    city: 'El Aaiun',
    country: 'EH',
    timezone: 'Africa/El_Aaiun',
    aliases: ['Laayoune'],
  },
  { city: 'Khartoum', country: 'SD', timezone: 'Africa/Khartoum' },
  { city: 'Juba', country: 'SS', timezone: 'Africa/Juba' },

  // ============================================================
  // AFRICA - West
  // ============================================================
  { city: 'Lagos', country: 'NG', timezone: 'Africa/Lagos' },
  { city: 'Abuja', country: 'NG', timezone: 'Africa/Lagos' },
  { city: 'Accra', country: 'GH', timezone: 'Africa/Abidjan' },
  { city: 'Abidjan', country: 'CI', timezone: 'Africa/Abidjan' },
  { city: 'Dakar', country: 'SN', timezone: 'Africa/Abidjan' },
  { city: 'Monrovia', country: 'LR', timezone: 'Africa/Monrovia' },
  { city: 'Bissau', country: 'GW', timezone: 'Africa/Bissau' },
  { city: 'Ndjamena', country: 'TD', timezone: 'Africa/Ndjamena' },
  { city: 'Sao Tome', country: 'ST', timezone: 'Africa/Sao_Tome' },

  // ============================================================
  // AFRICA - East
  // ============================================================
  { city: 'Nairobi', country: 'KE', timezone: 'Africa/Nairobi' },
  { city: 'Addis Ababa', country: 'ET', timezone: 'Africa/Nairobi' },
  { city: 'Dar es Salaam', country: 'TZ', timezone: 'Africa/Nairobi' },
  { city: 'Kampala', country: 'UG', timezone: 'Africa/Nairobi' },
  { city: 'Mogadishu', country: 'SO', timezone: 'Africa/Nairobi' },
  { city: 'Kigali', country: 'RW', timezone: 'Africa/Maputo' },

  // ============================================================
  // AFRICA - Southern & Central
  // ============================================================
  { city: 'Johannesburg', country: 'ZA', timezone: 'Africa/Johannesburg' },
  { city: 'Cape Town', country: 'ZA', timezone: 'Africa/Johannesburg' },
  { city: 'Durban', country: 'ZA', timezone: 'Africa/Johannesburg' },
  { city: 'Pretoria', country: 'ZA', timezone: 'Africa/Johannesburg' },
  { city: 'Maputo', country: 'MZ', timezone: 'Africa/Maputo' },
  { city: 'Harare', country: 'ZW', timezone: 'Africa/Maputo' },
  { city: 'Lusaka', country: 'ZM', timezone: 'Africa/Maputo' },
  { city: 'Windhoek', country: 'NA', timezone: 'Africa/Windhoek' },
  { city: 'Gaborone', country: 'BW', timezone: 'Africa/Maputo' },
  { city: 'Kinshasa', country: 'CD', timezone: 'Africa/Lagos' },
  { city: 'Luanda', country: 'AO', timezone: 'Africa/Lagos' },
  { city: 'Douala', country: 'CM', timezone: 'Africa/Lagos' },
  { city: 'Libreville', country: 'GA', timezone: 'Africa/Lagos' },
  { city: 'Brazzaville', country: 'CG', timezone: 'Africa/Lagos' },
  { city: 'Lubumbashi', country: 'CD', timezone: 'Africa/Maputo' },

  // ============================================================
  // OCEANIA - Australia
  // ============================================================
  { city: 'Sydney', country: 'AU', timezone: 'Australia/Sydney' },
  { city: 'Melbourne', country: 'AU', timezone: 'Australia/Melbourne' },
  { city: 'Brisbane', country: 'AU', timezone: 'Australia/Brisbane' },
  { city: 'Gold Coast', country: 'AU', timezone: 'Australia/Brisbane' },
  { city: 'Perth', country: 'AU', timezone: 'Australia/Perth' },
  { city: 'Adelaide', country: 'AU', timezone: 'Australia/Adelaide' },
  { city: 'Hobart', country: 'AU', timezone: 'Australia/Hobart' },
  { city: 'Darwin', country: 'AU', timezone: 'Australia/Darwin' },
  { city: 'Broken Hill', country: 'AU', timezone: 'Australia/Broken_Hill' },
  { city: 'Lindeman', country: 'AU', timezone: 'Australia/Lindeman' },
  { city: 'Lord Howe Island', country: 'AU', timezone: 'Australia/Lord_Howe' },
  { city: 'Eucla', country: 'AU', timezone: 'Australia/Eucla' },
  { city: 'Macquarie Island', country: 'AU', timezone: 'Antarctica/Macquarie' },
  { city: 'Canberra', country: 'AU', timezone: 'Australia/Sydney' },

  // ============================================================
  // OCEANIA - New Zealand & Pacific
  // ============================================================
  { city: 'Auckland', country: 'NZ', timezone: 'Pacific/Auckland' },
  { city: 'Wellington', country: 'NZ', timezone: 'Pacific/Auckland' },
  { city: 'Christchurch', country: 'NZ', timezone: 'Pacific/Auckland' },
  { city: 'Chatham Islands', country: 'NZ', timezone: 'Pacific/Chatham' },
  { city: 'Suva', country: 'FJ', timezone: 'Pacific/Fiji' },
  { city: 'Port Moresby', country: 'PG', timezone: 'Pacific/Port_Moresby' },
  { city: 'Bougainville', country: 'PG', timezone: 'Pacific/Bougainville' },
  { city: 'Noumea', country: 'NC', timezone: 'Pacific/Noumea' },
  { city: 'Port Vila', country: 'VU', timezone: 'Pacific/Efate' },
  { city: 'Honiara', country: 'SB', timezone: 'Pacific/Guadalcanal' },
  { city: 'Apia', country: 'WS', timezone: 'Pacific/Apia' },
  { city: "Nuku'alofa", country: 'TO', timezone: 'Pacific/Tongatapu' },
  { city: 'Tarawa', country: 'KI', timezone: 'Pacific/Tarawa' },
  { city: 'Majuro', country: 'MH', timezone: 'Pacific/Kwajalein' },
  { city: 'Kwajalein', country: 'MH', timezone: 'Pacific/Kwajalein' },
  { city: 'Kosrae', country: 'FM', timezone: 'Pacific/Kosrae' },
  { city: 'Nauru', country: 'NR', timezone: 'Pacific/Nauru' },
  { city: 'Norfolk Island', country: 'NF', timezone: 'Pacific/Norfolk' },
  { city: 'Pago Pago', country: 'AS', timezone: 'Pacific/Pago_Pago' },
  {
    city: 'Guam',
    country: 'GU',
    timezone: 'Pacific/Guam',
    aliases: ['Hagatna'],
  },
  {
    city: 'Palau',
    country: 'PW',
    timezone: 'Pacific/Palau',
    aliases: ['Koror'],
  },
  { city: 'Rarotonga', country: 'CK', timezone: 'Pacific/Rarotonga' },
  {
    city: 'Papeete',
    country: 'PF',
    timezone: 'Pacific/Tahiti',
    aliases: ['Tahiti'],
  },
  { city: 'Gambier Islands', country: 'PF', timezone: 'Pacific/Gambier' },
  { city: 'Marquesas Islands', country: 'PF', timezone: 'Pacific/Marquesas' },
  { city: 'Niue', country: 'NU', timezone: 'Pacific/Niue' },
  { city: 'Pitcairn', country: 'PN', timezone: 'Pacific/Pitcairn' },
  {
    city: 'Kiritimati',
    country: 'KI',
    timezone: 'Pacific/Kiritimati',
    aliases: ['Christmas Island'],
  },
  { city: 'Kanton', country: 'KI', timezone: 'Pacific/Kanton' },
  { city: 'Fakaofo', country: 'TK', timezone: 'Pacific/Fakaofo' },
  {
    city: 'Easter Island',
    country: 'CL',
    timezone: 'Pacific/Easter',
    aliases: ['Rapa Nui'],
  },
  { city: 'Galapagos', country: 'EC', timezone: 'Pacific/Galapagos' },

  // ============================================================
  // ATLANTIC
  // ============================================================
  {
    city: 'Bermuda',
    country: 'BM',
    timezone: 'Atlantic/Bermuda',
    aliases: ['Hamilton'],
  },
  {
    city: 'Azores',
    country: 'PT',
    timezone: 'Atlantic/Azores',
    aliases: ['Ponta Delgada'],
  },
  {
    city: 'Faroe Islands',
    country: 'FO',
    timezone: 'Atlantic/Faroe',
    aliases: ['Torshavn'],
  },
  {
    city: 'Canary Islands',
    country: 'ES',
    timezone: 'Atlantic/Canary',
    aliases: ['Las Palmas', 'Tenerife'],
  },
  {
    city: 'Madeira',
    country: 'PT',
    timezone: 'Atlantic/Madeira',
    aliases: ['Funchal'],
  },
  {
    city: 'Cape Verde',
    country: 'CV',
    timezone: 'Atlantic/Cape_Verde',
    aliases: ['Praia'],
  },
  { city: 'South Georgia', country: 'GS', timezone: 'Atlantic/South_Georgia' },

  // ============================================================
  // INDIAN OCEAN
  // ============================================================
  {
    city: 'Mauritius',
    country: 'MU',
    timezone: 'Indian/Mauritius',
    aliases: ['Port Louis'],
  },
  {
    city: 'Maldives',
    country: 'MV',
    timezone: 'Indian/Maldives',
    aliases: ['Male'],
  },
  {
    city: 'Chagos',
    country: 'IO',
    timezone: 'Indian/Chagos',
    aliases: ['Diego Garcia'],
  },

  // ============================================================
  // ANTARCTICA
  // ============================================================
  { city: 'Casey Station', country: 'AQ', timezone: 'Antarctica/Casey' },
  { city: 'Davis Station', country: 'AQ', timezone: 'Antarctica/Davis' },
  { city: 'Mawson Station', country: 'AQ', timezone: 'Antarctica/Mawson' },
  { city: 'Palmer Station', country: 'AQ', timezone: 'Antarctica/Palmer' },
  { city: 'Rothera Station', country: 'AQ', timezone: 'Antarctica/Rothera' },
  { city: 'Troll Station', country: 'AQ', timezone: 'Antarctica/Troll' },
  { city: 'Vostok Station', country: 'AQ', timezone: 'Antarctica/Vostok' },

  // ============================================================
  // GREENLAND & NORTH ATLANTIC
  // ============================================================
  {
    city: 'Nuuk',
    country: 'GL',
    timezone: 'America/Nuuk',
    aliases: ['Godthab'],
  },
  { city: 'Danmarkshavn', country: 'GL', timezone: 'America/Danmarkshavn' },
  {
    city: 'Scoresbysund',
    country: 'GL',
    timezone: 'America/Scoresbysund',
    aliases: ['Ittoqqortoormiit'],
  },
  {
    city: 'Thule',
    country: 'GL',
    timezone: 'America/Thule',
    aliases: ['Pituffik'],
  },
  {
    city: 'Miquelon',
    country: 'PM',
    timezone: 'America/Miquelon',
    aliases: ['Saint-Pierre'],
  },

  // ============================================================
  // ADDITIONAL MAJOR CITIES (aliases to existing timezones)
  // ============================================================

  // Additional US cities
  { city: 'Omaha', country: 'US', timezone: 'America/Chicago' },
  { city: 'Cincinnati', country: 'US', timezone: 'America/New_York' },
  { city: 'Cleveland', country: 'US', timezone: 'America/New_York' },
  { city: 'Columbus', country: 'US', timezone: 'America/New_York' },
  { city: 'Virginia Beach', country: 'US', timezone: 'America/New_York' },
  { city: 'Jacksonville', country: 'US', timezone: 'America/New_York' },
  { city: 'Fort Worth', country: 'US', timezone: 'America/Chicago' },
  { city: 'El Paso', country: 'US', timezone: 'America/Denver' },
  { city: 'Tulsa', country: 'US', timezone: 'America/Chicago' },
  { city: 'Fresno', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'Oakland', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'San Jose', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'Scottsdale', country: 'US', timezone: 'America/Phoenix' },

  // Additional European cities
  { city: 'Antwerp', country: 'BE', timezone: 'Europe/Brussels' },
  { city: 'Rotterdam', country: 'NL', timezone: 'Europe/Brussels' },
  { city: 'Gothenburg', country: 'SE', timezone: 'Europe/Berlin' },
  { city: 'Thessaloniki', country: 'GR', timezone: 'Europe/Athens' },
  {
    city: 'Florence',
    country: 'IT',
    timezone: 'Europe/Rome',
    aliases: ['Firenze'],
  },
  {
    city: 'Venice',
    country: 'IT',
    timezone: 'Europe/Rome',
    aliases: ['Venezia'],
  },
  {
    city: 'Turin',
    country: 'IT',
    timezone: 'Europe/Rome',
    aliases: ['Torino'],
  },
  {
    city: 'Dusseldorf',
    country: 'DE',
    timezone: 'Europe/Berlin',
    aliases: ['Düsseldorf'],
  },
  { city: 'Stuttgart', country: 'DE', timezone: 'Europe/Berlin' },
  { city: 'Hannover', country: 'DE', timezone: 'Europe/Berlin' },
  { city: 'Nice', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Toulouse', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Bordeaux', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Valencia', country: 'ES', timezone: 'Europe/Madrid' },
  { city: 'Bilbao', country: 'ES', timezone: 'Europe/Madrid' },
  {
    city: 'Malaga',
    country: 'ES',
    timezone: 'Europe/Madrid',
    aliases: ['Málaga'],
  },
  { city: 'Wroclaw', country: 'PL', timezone: 'Europe/Warsaw' },
  { city: 'Gdansk', country: 'PL', timezone: 'Europe/Warsaw' },
  { city: 'Cluj-Napoca', country: 'RO', timezone: 'Europe/Bucharest' },
  { city: 'Bratislava', country: 'SK', timezone: 'Europe/Prague' },
  { city: 'Brno', country: 'CZ', timezone: 'Europe/Prague' },
  { city: 'Izmir', country: 'TR', timezone: 'Europe/Istanbul' },
  { city: 'Ankara', country: 'TR', timezone: 'Europe/Istanbul' },

  // Additional Asian cities
  { city: 'Surabaya', country: 'ID', timezone: 'Asia/Jakarta' },
  { city: 'Bandung', country: 'ID', timezone: 'Asia/Jakarta' },
  { city: 'Cebu', country: 'PH', timezone: 'Asia/Manila' },
  { city: 'Davao', country: 'PH', timezone: 'Asia/Manila' },
  { city: 'Chiang Mai', country: 'TH', timezone: 'Asia/Bangkok' },
  { city: 'Phuket', country: 'TH', timezone: 'Asia/Bangkok' },
  { city: 'Siem Reap', country: 'KH', timezone: 'Asia/Bangkok' },
  {
    city: 'Penang',
    country: 'MY',
    timezone: 'Asia/Singapore',
    aliases: ['George Town'],
  },
  { city: 'Nagoya', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Fukuoka', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Sapporo', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Wuhan', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Hangzhou', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Nanjing', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Chongqing', country: 'CN', timezone: 'Asia/Shanghai' },
  {
    city: 'Xian',
    country: 'CN',
    timezone: 'Asia/Shanghai',
    aliases: ["Xi'an"],
  },
  { city: 'Incheon', country: 'KR', timezone: 'Asia/Seoul' },
  { city: 'Daegu', country: 'KR', timezone: 'Asia/Seoul' },
  { city: 'Ahmedabad', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Jaipur', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Lucknow', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Surat', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Faisalabad', country: 'PK', timezone: 'Asia/Karachi' },
  { city: 'Rawalpindi', country: 'PK', timezone: 'Asia/Karachi' },
  { city: 'Chittagong', country: 'BD', timezone: 'Asia/Dhaka' },

  // Additional Middle East cities
  { city: 'Manama', country: 'BH', timezone: 'Asia/Qatar' },
  { city: 'Abu Dhabi', country: 'AE', timezone: 'Asia/Dubai' },
  { city: 'Sharjah', country: 'AE', timezone: 'Asia/Dubai' },
  { city: 'Medina', country: 'SA', timezone: 'Asia/Riyadh' },
  { city: 'Dammam', country: 'SA', timezone: 'Asia/Riyadh' },
  { city: 'Basra', country: 'IQ', timezone: 'Asia/Baghdad' },
  { city: 'Erbil', country: 'IQ', timezone: 'Asia/Baghdad' },
  { city: 'Isfahan', country: 'IR', timezone: 'Asia/Tehran' },
  { city: 'Tabriz', country: 'IR', timezone: 'Asia/Tehran' },

  // Additional African cities
  { city: 'Zanzibar', country: 'TZ', timezone: 'Africa/Nairobi' },
  { city: 'Mombasa', country: 'KE', timezone: 'Africa/Nairobi' },
  { city: 'Marrakech', country: 'MA', timezone: 'Africa/Casablanca' },
  { city: 'Fez', country: 'MA', timezone: 'Africa/Casablanca' },
  { city: 'Port Elizabeth', country: 'ZA', timezone: 'Africa/Johannesburg' },
  { city: 'Bloemfontein', country: 'ZA', timezone: 'Africa/Johannesburg' },

  // Additional South American cities
  { city: 'Curitiba', country: 'BR', timezone: 'America/Sao_Paulo' },
  {
    city: 'Brasilia',
    country: 'BR',
    timezone: 'America/Sao_Paulo',
    aliases: ['Brasília'],
  },
  { city: 'Belo Horizonte', country: 'BR', timezone: 'America/Sao_Paulo' },
  { city: 'Porto Alegre', country: 'BR', timezone: 'America/Sao_Paulo' },
  { city: 'Cali', country: 'CO', timezone: 'America/Bogota' },
  { city: 'Barranquilla', country: 'CO', timezone: 'America/Bogota' },
  {
    city: 'Cusco',
    country: 'PE',
    timezone: 'America/Lima',
    aliases: ['Cuzco'],
  },
  {
    city: 'Rosario',
    country: 'AR',
    timezone: 'America/Argentina/Buenos_Aires',
  },
  {
    city: 'Valparaiso',
    country: 'CL',
    timezone: 'America/Santiago',
    aliases: ['Valparaíso'],
  },

  // Additional Oceanian cities
  { city: 'Cairns', country: 'AU', timezone: 'Australia/Brisbane' },
  { city: 'Townsville', country: 'AU', timezone: 'Australia/Brisbane' },
  { city: 'Geelong', country: 'AU', timezone: 'Australia/Melbourne' },
  { city: 'Wollongong', country: 'AU', timezone: 'Australia/Sydney' },
  { city: 'Newcastle', country: 'AU', timezone: 'Australia/Sydney' },

  // Additional Canadian cities
  { city: 'Victoria', country: 'CA', timezone: 'America/Vancouver' },
  { city: 'Saskatoon', country: 'CA', timezone: 'America/Regina' },
  { city: 'London', country: 'CA', timezone: 'America/Toronto' },
  { city: 'Hamilton', country: 'CA', timezone: 'America/Toronto' },
  { city: 'Quebec City', country: 'CA', timezone: 'America/Toronto' },
  { city: 'Kitchener', country: 'CA', timezone: 'America/Toronto' },

  // Additional US cities
  { city: 'Buffalo', country: 'US', timezone: 'America/New_York' },
  { city: 'Richmond', country: 'US', timezone: 'America/New_York' },
  { city: 'Hartford', country: 'US', timezone: 'America/New_York' },
  { city: 'Providence', country: 'US', timezone: 'America/New_York' },
  { city: 'Rochester', country: 'US', timezone: 'America/New_York' },
  { city: 'Savannah', country: 'US', timezone: 'America/New_York' },
  { city: 'Des Moines', country: 'US', timezone: 'America/Chicago' },
  { city: 'Madison', country: 'US', timezone: 'America/Chicago' },
  { city: 'Little Rock', country: 'US', timezone: 'America/Chicago' },
  { city: 'Wichita', country: 'US', timezone: 'America/Chicago' },
  { city: 'Baton Rouge', country: 'US', timezone: 'America/Chicago' },
  { city: 'Reno', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'Spokane', country: 'US', timezone: 'America/Los_Angeles' },
  { city: 'Santa Fe', country: 'US', timezone: 'America/Denver' },
  { city: 'Fairbanks', country: 'US', timezone: 'America/Anchorage' },

  // Additional European cities
  { city: 'Reykjavik', country: 'IS', timezone: 'Atlantic/Reykjavik' },
  { city: 'Strasbourg', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Nantes', country: 'FR', timezone: 'Europe/Paris' },
  { city: 'Nuremberg', country: 'DE', timezone: 'Europe/Berlin' },
  { city: 'Leipzig', country: 'DE', timezone: 'Europe/Berlin' },
  { city: 'Dresden', country: 'DE', timezone: 'Europe/Berlin' },
  { city: 'Bologna', country: 'IT', timezone: 'Europe/Rome' },
  { city: 'Palermo', country: 'IT', timezone: 'Europe/Rome' },
  {
    city: 'Genoa',
    country: 'IT',
    timezone: 'Europe/Rome',
    aliases: ['Genova'],
  },
  {
    city: 'The Hague',
    country: 'NL',
    timezone: 'Europe/Brussels',
    aliases: ['Den Haag'],
  },
  { city: 'Utrecht', country: 'NL', timezone: 'Europe/Brussels' },
  { city: 'Eindhoven', country: 'NL', timezone: 'Europe/Brussels' },
  { city: 'Aarhus', country: 'DK', timezone: 'Europe/Berlin' },
  {
    city: 'Malmo',
    country: 'SE',
    timezone: 'Europe/Berlin',
    aliases: ['Malmö'],
  },
  { city: 'Tampere', country: 'FI', timezone: 'Europe/Helsinki' },
  { city: 'Turku', country: 'FI', timezone: 'Europe/Helsinki' },
  { city: 'Debrecen', country: 'HU', timezone: 'Europe/Budapest' },
  { city: 'Lviv', country: 'UA', timezone: 'Europe/Kyiv' },
  { city: 'Odessa', country: 'UA', timezone: 'Europe/Kyiv' },
  { city: 'Kharkiv', country: 'UA', timezone: 'Europe/Kyiv' },
  { city: 'Constanta', country: 'RO', timezone: 'Europe/Bucharest' },
  { city: 'Plovdiv', country: 'BG', timezone: 'Europe/Sofia' },
  { city: 'Tartu', country: 'EE', timezone: 'Europe/Tallinn' },
  { city: 'Dubrovnik', country: 'HR', timezone: 'Europe/Belgrade' },
  { city: 'Split', country: 'HR', timezone: 'Europe/Belgrade' },
  { city: 'Nizhny Novgorod', country: 'RU', timezone: 'Europe/Moscow' },
  { city: 'Kazan', country: 'RU', timezone: 'Europe/Moscow' },
  { city: 'Rostov-on-Don', country: 'RU', timezone: 'Europe/Moscow' },

  // Additional Asian cities
  { city: 'Tianjin', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Shantou', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Dongguan', country: 'CN', timezone: 'Asia/Shanghai' },
  { city: 'Yokohama', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Kobe', country: 'JP', timezone: 'Asia/Tokyo' },
  { city: 'Gwangju', country: 'KR', timezone: 'Asia/Seoul' },
  { city: 'Kaohsiung', country: 'TW', timezone: 'Asia/Taipei' },
  { city: 'Taichung', country: 'TW', timezone: 'Asia/Taipei' },
  { city: 'Batam', country: 'ID', timezone: 'Asia/Jakarta' },
  { city: 'Semarang', country: 'ID', timezone: 'Asia/Jakarta' },
  { city: 'Johor Bahru', country: 'MY', timezone: 'Asia/Singapore' },
  { city: 'Vientiane', country: 'LA', timezone: 'Asia/Bangkok' },
  { city: 'Da Nang', country: 'VN', timezone: 'Asia/Ho_Chi_Minh' },
  { city: 'Kochi', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Chandigarh', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Indore', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Coimbatore', country: 'IN', timezone: 'Asia/Kolkata' },
  { city: 'Peshawar', country: 'PK', timezone: 'Asia/Karachi' },
  { city: 'Sylhet', country: 'BD', timezone: 'Asia/Dhaka' },
  { city: 'Batumi', country: 'GE', timezone: 'Asia/Tbilisi' },

  // Additional South American cities
  { city: 'Cartagena', country: 'CO', timezone: 'America/Bogota' },
  { city: 'Arequipa', country: 'PE', timezone: 'America/Lima' },
  { city: 'Concepcion', country: 'CL', timezone: 'America/Santiago' },
  {
    city: 'Mar del Plata',
    country: 'AR',
    timezone: 'America/Argentina/Buenos_Aires',
  },
  { city: 'Salvador', country: 'BR', timezone: 'America/Bahia' },
  { city: 'Florianopolis', country: 'BR', timezone: 'America/Sao_Paulo' },
  { city: 'Campinas', country: 'BR', timezone: 'America/Sao_Paulo' },
  { city: 'Goiania', country: 'BR', timezone: 'America/Sao_Paulo' },

  // Additional African cities
  { city: 'Kumasi', country: 'GH', timezone: 'Africa/Abidjan' },
  { city: 'Ibadan', country: 'NG', timezone: 'Africa/Lagos' },
  { city: 'Port Harcourt', country: 'NG', timezone: 'Africa/Lagos' },
  { city: 'Enugu', country: 'NG', timezone: 'Africa/Lagos' },
  { city: 'Arusha', country: 'TZ', timezone: 'Africa/Nairobi' },
  { city: 'Antananarivo', country: 'MG', timezone: 'Africa/Nairobi' },
  { city: 'Bamako', country: 'ML', timezone: 'Africa/Abidjan' },
  { city: 'Conakry', country: 'GN', timezone: 'Africa/Abidjan' },
  { city: 'Ouagadougou', country: 'BF', timezone: 'Africa/Abidjan' },
  { city: 'Lome', country: 'TG', timezone: 'Africa/Abidjan' },
  { city: 'Cotonou', country: 'BJ', timezone: 'Africa/Lagos' },
  { city: 'Niamey', country: 'NE', timezone: 'Africa/Lagos' },
  { city: 'Yaounde', country: 'CM', timezone: 'Africa/Lagos' },
  { city: 'Lilongwe', country: 'MW', timezone: 'Africa/Maputo' },
  { city: 'Blantyre', country: 'MW', timezone: 'Africa/Maputo' },
  { city: 'Bujumbura', country: 'BI', timezone: 'Africa/Maputo' },
  { city: 'Asmara', country: 'ER', timezone: 'Africa/Nairobi' },
  { city: 'Djibouti', country: 'DJ', timezone: 'Africa/Nairobi' },
]

/**
 * Maps timezone search terms (abbreviations, common names, UTC/GMT offsets)
 * to arrays of IANA timezone IDs. All keys MUST be lowercase.
 * Used by searchCities() to match non-city queries.
 */
export const TIMEZONE_SEARCH_TERMS: Record<string, string[]> = {
  // ---- Abbreviations ----
  // North America
  est: ['America/New_York'],
  edt: ['America/New_York'],
  cst: ['America/Chicago'],
  cdt: ['America/Chicago'],
  mst: ['America/Denver'],
  mdt: ['America/Denver'],
  pst: ['America/Los_Angeles'],
  pdt: ['America/Los_Angeles'],
  akst: ['America/Anchorage'],
  akdt: ['America/Anchorage'],
  hst: ['Pacific/Honolulu'],
  ast: ['America/Halifax'],
  adt: ['America/Halifax'],
  nst: ['America/St_Johns'],
  ndt: ['America/St_Johns'],

  // Europe
  gmt: ['Europe/London'],
  bst: ['Europe/London'],
  wet: ['Europe/Lisbon'],
  west: ['Europe/Lisbon'],
  cet: [
    'Europe/Berlin',
    'Europe/Paris',
    'Europe/Rome',
    'Europe/Madrid',
    'Europe/Brussels',
  ],
  cest: [
    'Europe/Berlin',
    'Europe/Paris',
    'Europe/Rome',
    'Europe/Madrid',
    'Europe/Brussels',
  ],
  eet: ['Europe/Helsinki', 'Europe/Bucharest', 'Europe/Sofia', 'Europe/Athens'],
  eest: [
    'Europe/Helsinki',
    'Europe/Bucharest',
    'Europe/Sofia',
    'Europe/Athens',
  ],
  msk: ['Europe/Moscow'],
  ist: ['Asia/Kolkata', 'Europe/Dublin'],

  // Asia and Middle East
  jst: ['Asia/Tokyo'],
  kst: ['Asia/Seoul'],
  'cst asia': ['Asia/Shanghai'],
  hkt: ['Asia/Hong_Kong'],
  sgt: ['Asia/Singapore'],
  wib: ['Asia/Jakarta'],
  wita: ['Asia/Makassar'],
  wit: ['Asia/Jayapura'],
  pht: ['Asia/Manila'],
  ict: ['Asia/Bangkok'],
  mmt: ['Asia/Yangon'],
  bdt: ['Asia/Dhaka'],
  pkt: ['Asia/Karachi'],
  aft: ['Asia/Kabul'],
  irst: ['Asia/Tehran'],
  gst: ['Asia/Dubai'],
  'ast arabia': ['Asia/Riyadh'],
  trt: ['Europe/Istanbul'],

  // Oceania
  aest: ['Australia/Sydney', 'Australia/Melbourne', 'Australia/Brisbane'],
  aedt: ['Australia/Sydney', 'Australia/Melbourne'],
  acst: ['Australia/Adelaide'],
  acdt: ['Australia/Adelaide'],
  awst: ['Australia/Perth'],
  nzst: ['Pacific/Auckland'],
  nzdt: ['Pacific/Auckland'],

  // South America
  brt: ['America/Sao_Paulo'],
  brst: ['America/Sao_Paulo'],
  art: ['America/Argentina/Buenos_Aires'],
  clt: ['America/Santiago'],
  clst: ['America/Santiago'],
  pet: ['America/Lima'],
  cot: ['America/Bogota'],
  vet: ['America/Caracas'],

  // Africa
  cat: ['Africa/Maputo'],
  eat: ['Africa/Nairobi'],
  wat: ['Africa/Lagos'],
  sast: ['Africa/Johannesburg'],

  // ---- Common names ----
  eastern: ['America/New_York'],
  'eastern time': ['America/New_York'],
  central: ['America/Chicago'],
  'central time': ['America/Chicago'],
  mountain: ['America/Denver'],
  'mountain time': ['America/Denver'],
  pacific: ['America/Los_Angeles'],
  'pacific time': ['America/Los_Angeles'],
  alaska: ['America/Anchorage'],
  hawaii: ['Pacific/Honolulu'],
  atlantic: ['America/Halifax'],
  greenwich: ['Europe/London'],
  'greenwich mean time': ['Europe/London'],
  'central european': ['Europe/Berlin', 'Europe/Paris'],
  'central european time': ['Europe/Berlin', 'Europe/Paris'],
  'eastern european': ['Europe/Helsinki', 'Europe/Bucharest'],
  'eastern european time': ['Europe/Helsinki', 'Europe/Bucharest'],
  'western european': ['Europe/Lisbon'],
  'western european time': ['Europe/Lisbon'],
  'india standard': ['Asia/Kolkata'],
  'india standard time': ['Asia/Kolkata'],
  'japan standard': ['Asia/Tokyo'],
  'japan standard time': ['Asia/Tokyo'],
  'korea standard': ['Asia/Seoul'],
  'korea standard time': ['Asia/Seoul'],
  'china standard': ['Asia/Shanghai'],
  'china standard time': ['Asia/Shanghai'],
  'australian eastern': ['Australia/Sydney'],
  'australian central': ['Australia/Adelaide'],
  'australian western': ['Australia/Perth'],
  'new zealand': ['Pacific/Auckland'],
  arabian: ['Asia/Dubai'],
  'arabian standard time': ['Asia/Dubai'],
  'south africa': ['Africa/Johannesburg'],
  'south africa standard time': ['Africa/Johannesburg'],
  'west africa': ['Africa/Lagos'],
  'east africa': ['Africa/Nairobi'],
  moscow: ['Europe/Moscow'],
  'moscow time': ['Europe/Moscow'],
  indochina: ['Asia/Bangkok'],
  gulf: ['Asia/Dubai'],

  // ---- UTC/GMT offsets ----
  'utc-12': ['Etc/GMT+12'],
  'utc-11': ['Pacific/Pago_Pago'],
  'utc-10': ['Pacific/Honolulu'],
  'utc-9': ['America/Anchorage'],
  'utc-9:30': ['Pacific/Marquesas'],
  'utc-8': ['America/Los_Angeles'],
  'utc-7': ['America/Denver'],
  'utc-6': ['America/Chicago'],
  'utc-5': ['America/New_York'],
  'utc-4': ['America/Halifax'],
  'utc-3:30': ['America/St_Johns'],
  'utc-3': ['America/Sao_Paulo'],
  'utc-2': ['America/Noronha'],
  'utc-1': ['Atlantic/Azores'],
  'utc+0': ['Europe/London'],
  utc0: ['Europe/London'],
  utc: ['Europe/London'],
  'utc+1': ['Europe/Berlin'],
  'utc+2': ['Europe/Helsinki'],
  'utc+3': ['Europe/Moscow'],
  'utc+3:30': ['Asia/Tehran'],
  'utc+4': ['Asia/Dubai'],
  'utc+4:30': ['Asia/Kabul'],
  'utc+5': ['Asia/Karachi'],
  'utc+5:30': ['Asia/Kolkata'],
  'utc+5:45': ['Asia/Kathmandu'],
  'utc+6': ['Asia/Dhaka'],
  'utc+6:30': ['Asia/Yangon'],
  'utc+7': ['Asia/Bangkok'],
  'utc+8': ['Asia/Shanghai'],
  'utc+9': ['Asia/Tokyo'],
  'utc+9:30': ['Australia/Adelaide'],
  'utc+10': ['Australia/Sydney'],
  'utc+10:30': ['Australia/Lord_Howe'],
  'utc+11': ['Pacific/Noumea'],
  'utc+12': ['Pacific/Auckland'],
  'utc+13': ['Pacific/Tongatapu'],
  'utc+14': ['Pacific/Kiritimati'],

  // GMT aliases (same as UTC)
  'gmt-12': ['Etc/GMT+12'],
  'gmt-11': ['Pacific/Pago_Pago'],
  'gmt-10': ['Pacific/Honolulu'],
  'gmt-9': ['America/Anchorage'],
  'gmt-9:30': ['Pacific/Marquesas'],
  'gmt-8': ['America/Los_Angeles'],
  'gmt-7': ['America/Denver'],
  'gmt-6': ['America/Chicago'],
  'gmt-5': ['America/New_York'],
  'gmt-4': ['America/Halifax'],
  'gmt-3:30': ['America/St_Johns'],
  'gmt-3': ['America/Sao_Paulo'],
  'gmt-2': ['America/Noronha'],
  'gmt-1': ['Atlantic/Azores'],
  'gmt+0': ['Europe/London'],
  gmt0: ['Europe/London'],
  'gmt+1': ['Europe/Berlin'],
  'gmt+2': ['Europe/Helsinki'],
  'gmt+3': ['Europe/Moscow'],
  'gmt+4': ['Asia/Dubai'],
  'gmt+5': ['Asia/Karachi'],
  'gmt+5:30': ['Asia/Kolkata'],
  'gmt+6': ['Asia/Dhaka'],
  'gmt+7': ['Asia/Bangkok'],
  'gmt+8': ['Asia/Shanghai'],
  'gmt+9': ['Asia/Tokyo'],
  'gmt+10': ['Australia/Sydney'],
  'gmt+11': ['Pacific/Noumea'],
  'gmt+12': ['Pacific/Auckland'],
}

export const searchCities = (query: string, limit = 8): CityEntry[] => {
  if (!query || query.trim().length < 1) return []
  const normalizedQuery = query.toLowerCase().trim()
  const results: CityEntry[] = []
  const seenTimezones = new Set<string>()

  const addEntry = (entry: CityEntry): boolean => {
    if (results.length >= limit) return false
    if (seenTimezones.has(entry.timezone)) return false
    results.push(entry)
    seenTimezones.add(entry.timezone)
    return true
  }

  // Pass 1: prefix match on city name and aliases
  for (const entry of CITY_TIMEZONES) {
    if (results.length >= limit) break
    const matches =
      entry.city.toLowerCase().startsWith(normalizedQuery) ||
      entry.aliases?.some((alias) =>
        alias.toLowerCase().startsWith(normalizedQuery)
      )
    if (matches) addEntry(entry)
  }

  // Pass 2: substring match on city name and aliases
  if (results.length < limit) {
    for (const entry of CITY_TIMEZONES) {
      if (results.length >= limit) break
      const matches =
        entry.city.toLowerCase().includes(normalizedQuery) ||
        entry.aliases?.some((alias) =>
          alias.toLowerCase().includes(normalizedQuery)
        )
      if (matches) addEntry(entry)
    }
  }

  // Pass 3: match against timezone abbreviations, common names, and UTC/GMT offsets
  if (results.length < limit) {
    const matchedTimezoneIds = new Set<string>()

    for (const [term, timezoneIds] of Object.entries(TIMEZONE_SEARCH_TERMS)) {
      if (term === normalizedQuery || term.startsWith(normalizedQuery)) {
        for (const tz of timezoneIds) {
          matchedTimezoneIds.add(tz)
        }
      }
    }

    // Find city entries for matched timezone IDs
    if (matchedTimezoneIds.size > 0) {
      for (const entry of CITY_TIMEZONES) {
        if (results.length >= limit) break
        if (matchedTimezoneIds.has(entry.timezone)) {
          addEntry(entry)
        }
      }
    }
  }

  // Pass 4: match against IANA timezone ID (e.g. "america/new" matches "America/New_York")
  if (results.length < limit) {
    for (const entry of CITY_TIMEZONES) {
      if (results.length >= limit) break
      if (entry.timezone.toLowerCase().includes(normalizedQuery)) {
        addEntry(entry)
      }
    }
  }

  return results
}

export const findCityByTimezone = (timezone: string): CityEntry | undefined => {
  return CITY_TIMEZONES.find((entry) => entry.timezone === timezone)
}

export const findTimezoneByCity = (cityName: string): string | undefined => {
  const normalized = cityName.toLowerCase().trim()
  const entry = CITY_TIMEZONES.find(
    (e) =>
      e.city.toLowerCase() === normalized ||
      e.aliases?.some((alias) => alias.toLowerCase() === normalized)
  )
  return entry?.timezone
}

export const getTimezoneDisplayLabel = (
  timezone: string
): { cityLabel: string; timezoneLabel: string } => {
  const city = findCityByTimezone(timezone)
  const tz = getTimezone(timezone)

  const cityLabel = city
    ? `${city.city}, ${city.country}`
    : (timezone.split('/').pop()?.replace(/_/g, ' ') ?? timezone)

  const timezoneLabel = tz
    ? `${tz.name.replace(/_/g, ' ')} (${tz.utcOffsetStr})`
    : timezone

  return { cityLabel, timezoneLabel }
}
